<template>
    <div class="p-3">
        <h3>Tambah ICD 9 Details</h3>
        <hr>

        <div class="row">
            <div class="col-sm-12">
                <h4 class="mb-3">Data ICD 9 Tambah</h4>

                <div class="card">
                    <div class="card-header text-white bg-primary">Tambah ICD 9</div>
                    <div class="card-body">
                        <template v-for="(icd9, idx) in update_icd9">
                            <div class="row mb-12" :key="idx" v-if="input_labels[idx]">
                                <label :for="idx" class="col-sm-4 col-form-label text-end">{{ input_labels[idx] }}</label>
                                <div class="col-sm-6">
                                    <input :name="idx" v-if="!inArray(idx, input_filtered)" type="text" :id="idx" class="form-control" v-model="update_icd9[idx]"   @change="validate(idx)">
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-sm btn-success" @click="saveICD9">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            KDICD: '',
            update_icd9: {
                'KDICD': '',
                'Diagnosa': '',
                'KDDTD': '',

            },
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            },
            input_labels: {
                'KDICD': 'Kode ICD 9',
                'Diagnosa': 'Nama ICD 9',
                'KDDTD': 'Sub Kode ICD 9',

            },
            input_filtered: [],
        }
    },
    created() {
    },
    mounted() {
    },
    updated() {
      
    },
    methods: {
      
        validate(field) {
        },
        saveICD9() {
            const uri = '/api/master-icd9/save-icd9'
            this.axios.post(uri, {data_icd9: this.update_icd9}).then(response => {
                if (response.data.status == 'success') {
                    this.$router.push({
                        name: 'master_icd9'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        },
      
    }
}
</script>